//
import Model from '@/models/Model'

//
export default class SlCommission extends Model {
    /**
     *
     */
    resource() {
        return 'sl_commission'
    }
    get commPercentage() {
        try {
            let { percentage } = this
            if (percentage !== '') return `${this.percentage} %`
            else return '-'
        } catch (e) {
            return ''
        }
    }
}
